import dashboardsApi from 'common/src/modules/dashboards/dashboards.api';
import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {AccountAnalyticsToolName} from '../accountAnalyticsAgent.enums';

const inputSchema = z.object({});

function createAccountDashboardTool(shouldNavigate = true) {
  async function execute(): Promise<ToolResult> {
    const queryParams = {
      ...Object.fromEntries(new URLSearchParams(document.location.search).entries()),
    };

    const dashboardId = await dashboardsApi.createDashboard();

    if (shouldNavigate) {
      routingService.goTo({
        url: Routes.DashboardInfo,
        pathParams: {
          dashboardId: String(dashboardId),
        },
        queryParams,
      });
    }

    return toolResult(`Dashboard created with id: ${dashboardId}`);
  }

  return tool({
    name: AccountAnalyticsToolName.CreateAccountDashboard,
    displayName: 'Creating dashboard',
    description: 'create a dashboard',
    execute,
    inputSchema,
  });
}

export default createAccountDashboardTool;
